/*
 xu.ruliang 2017/04/13
 */
"use strict";
angular.module('newWindowManageSysManagesystemManagementModule', [])
    .controller('newWindowManageSysManagesystemManagementCtrl', ['$scope', '$modalInstance', 'Params', 'trsHttpService', 'modalDialog', function($scope, $modalInstance, Params, trsHttpService, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = angular.copy(Params);
            $scope.title = Params.DOMAINTOKENID == "0" ? "新建" : "修改";
            $scope.isShowLabel = "false";
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {

        }
        /**
         * [checkRepeatName 检查重名称]
         * @return {[type]} [true为重复 false为不重复]
         */
        $scope.checkRepeatName = function() {
            var params = {
                serviceid: "mlf_domaintoken",
                methodname: "uniqueDomainToken",
                DomainName: $scope.status.DOMAINNAME
            };
            // 如果更改过的域名和数据域名相同,不现提示
            if ($scope.status.DOMAINNAME == Params.DOMAINNAME) {
                $scope.isShowLabel = "false";
                return;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.isShowLabel = data.slice(1, -1);
            });
        };
        /**
         * [cancel 取消]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm 确定]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            // 如果更改过的域名和数据域名相同并且密钥相同,直接关闭窗口,不发生任何操作
            if ($scope.status.DOMAINNAME == Params.DOMAINNAME && $scope.status.TOKEN == Params.TOKEN) {
                $modalInstance.dismiss();
                return;
            }
            if ($scope.isShowLabel == "true") {
                modalDialog.alertType('域名名重复', "请检查填写项", "warning", false);
                return;
            }
            $modalInstance.close($scope.status);
        };
    }]);
